export const init = ({
  adminEmail,
  clientId,
  clientName,
  totangoId,
}) => {
  window.totango_options = {
    // TODO EER-124 need to replace with actual totango IDs from properties file
    service_id: totangoId,
    user: {
      id: adminEmail,
    },
    account: {
      id: clientId,
      name: clientName,
    },
  };
  // eslint-disable-next-line func-names
  (function () {
    const trackerName = window.totango_options.tracker_name || 'totango';
    window.totango_tmp_stack = [];
    window[trackerName] = {
      go() { return -1; },
      setAccountAttributes() {},
      identify() {},
      track(t, o, n, a) {
        window.totango_tmp_stack.push({
          activity: t, module: o, org: n, user: a,
        }); return -1;
      },
    };
    const e = document.createElement('script'); e.type = 'text/javascript'; e.async = true;
    e.src = `${document.location.protocol === 'https:' ? 'https://' : 'http://'}tracker.totango.com/totango3.js`;
    const s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(e, s);
  }());
};

export default init;
